import { fetchApi } from 'gossamer-front-end';
import { useEffect, useState } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { SummaryResponse, SummaryResultRow } from 'cb-model';
import styles from './Summary.module.css';

interface SummaryProps {
  institutionId?: number;
  institutionGroupId?: number;
  userId?: string;
}

export const Summary = (props: SummaryProps) => {
  const now = new Date().toISOString().substring(0, 10);
  const oneYearAgo = new Date();
  oneYearAgo.setDate(oneYearAgo.getDate() - 365);
  const [startDate, setStartDate] = useState(oneYearAgo.toISOString().substring(0, 10));
  const [endDate, setEndDate] = useState(now);
  const response = useSummaryData(
    startDate,
    endDate,
    props.institutionId || null,
    props.institutionGroupId || null,
    props.userId || null,
  );

  return (
    <div>
      {!!response && <AllTiles data={response} />}
      <InputGroup>
        <InputGroup.Text>Date Range:</InputGroup.Text>
        <FormControl
          type="date"
          value={startDate}
          max={endDate}
          name="start_date"
          onChange={(e) => setStartDate(e.target.value)}
        />
        <InputGroup.Text> to </InputGroup.Text>
        <FormControl
          type="date"
          value={endDate}
          min={startDate}
          name="end_date"
          onChange={(e) => setEndDate(e.target.value)}
        />
      </InputGroup>
    </div>
  );
};

export const useSummaryData = (
  startDate: string,
  endDate: string,
  institutionId: number | null,
  institutionGroupId: number | null,
  userId: string | null,
) => {
  const [data, setData] = useState<SummaryResponse | null>(null);
  useEffect(() => {
    if (!!startDate && !!endDate) {
      fetchApi(
        'GET',
        '/main/reporting/summary' +
          '?start_date=' +
          encodeURIComponent(startDate) +
          '&end_date=' +
          encodeURIComponent(endDate) +
          (institutionId ? '&institution_id=' + institutionId : '') +
          (institutionGroupId ? '&institution_group_id=' + institutionGroupId : '') +
          (userId ? '&user_id=' + userId : ''),
      )
        .then((data) => {
          setData(data);
        })
        .catch(console.error);
    }
  }, [startDate, endDate, institutionId, institutionGroupId, userId]);
  return data;
};

interface AllTilesProps {
  data: SummaryResultRow;
  hideEvents?: boolean; // for users, events = bookings
}

export const AllTiles = (props: AllTilesProps) => (
  <div className={styles.SummaryBlock}>
    {/* <SummaryTile main={String(props.data.event_count)} sub="All Events" />
    <SummaryTile main={String(props.data.booking_count)} sub="All Bookings" />
    <SummaryTile
      main={props.data.event_count === 0 ? '-' : (props.data.booking_count / props.data.event_count).toFixed(1)}
      sub="All Booking Rate"
    /> */}
    {!props.hideEvents && <SummaryTile main={String(props.data.event_count)} sub="All Events" />}
    <SummaryTile main={String(props.data.booking_count)} sub="All Bookings" />
    {!props.hideEvents && (
      <SummaryTile
        main={props.data.event_count === 0 ? '-' : (props.data.booking_count / props.data.event_count).toFixed(1)}
        sub="Booking Rate"
        highlight={true}
      />
    )}
    <SummaryTile main={String(props.data.post_event_booking_count)} sub="Tracked Bookings" />
    <SummaryTile main={String(props.data.attendance_count)} sub="Attendances" />
    <SummaryTile
      main={
        props.data.post_event_booking_count === 0
          ? '-'
          : ((props.data.attendance_count * 100) / props.data.post_event_booking_count).toFixed(0) + '%'
      }
      sub="Attendance Rate"
      highlight={true}
    />
  </div>
);

interface SummaryTileProps {
  main: string;
  sub: string;
  highlight?: boolean;
}

const SummaryTile = (props: SummaryTileProps) => (
  <div className={props.highlight ? 'highlight' : ''}>
    <div className="sub">{props.sub}</div>
    <div className="main">{props.main}</div>
  </div>
);
